import { useMemo } from 'react'

import i18n from 'modules/core/lib/i18n'

import { getTextFromNodeType } from 'modules/job_catalog/lib/nodesUtils'

export const useNodeModalContent = (type: string | null, nodeName: string, childType: string) =>
  useMemo(() => {
    const safeChildType = getTextFromNodeType(childType)
    if (type === 'create') {
      return {
        title: i18n.t('job_catalog.nodes.modal.create_title', { type: safeChildType }),
        description: i18n.t('job_catalog.nodes.modal.create_description', {
          type: safeChildType,
          name: nodeName,
        }),
        icon: 'input-field',
      } as const
    }

    if (type === 'duplicate') {
      return {
        title: i18n.t('job_catalog.nodes.modal.duplicate_title', { type: safeChildType }),
        description: i18n.t('job_catalog.nodes.modal.duplicate_description', {
          type: safeChildType,
          name: nodeName,
        }),
      } as const
    }

    if (type === 'edit') {
      return {
        title: i18n.t('job_catalog.nodes.modal.edit_title', {
          name: nodeName,
          type: safeChildType,
        }),
        description: i18n.t('job_catalog.nodes.modal.edit_description', { type: safeChildType }),
        icon: 'pencil',
      } as const
    }

    return {
      title: '',
      description: '',
      icon: 'check',
    } as const
  }, [type, nodeName, childType])
